// extracted by mini-css-extract-plugin
module.exports = {"titleFilter":"index_titleFilter__fp4R_","input":"index_input__HNRhm","suffix":"index_suffix__vO3Lv"};